module.exports = __webpack_public_path__ + "img/install-teacher.0ed651ba.jpg";